<template>
    <div class="inquiry-wrap mobile-toast-popup" :class="[{active : visibleOrdersFilterMobileToastPopup}]">
        <div class="opacity-bg pc-none" @click.prevent="closeResultFilter"></div>
        <div class="order-history-inquiry toast-layout">
            <div class="toast-name pc-none">주문조회 설정</div>
            <div class="inquiry-filter position-relative">
                <button @click.self="reset" class="btn__reset btn-xs position-absolute tablet-none">초기화</button>
                <div class="inquiry-filter__primary">
                    <div class="filter__item filter__item-date">
                        <p class="filter__title">주문일</p>
                        <div class="filter__body filter__body filter__body-date">
                            <ul class="body__btns body__btns-date">
                                <li>
                                    <input class="visually-hidden" type="radio" id="searchOneMonth" value="ONE_MONTH" v-model="searchMonth" @click="chkSearchMonthVal($event)">
                                    <label class="btn-m btn-filter" for="searchOneMonth">1개월</label>
                                </li>
                                <li>
                                    <input class="visually-hidden" type="radio" id="searchThreeMonth" value="THREE_MONTH" v-model="searchMonth" @click="chkSearchMonthVal($event)">
                                    <label class="btn-m btn-filter" for="searchThreeMonth">3개월</label>
                                </li>
                                <li>
                                    <input class="visually-hidden" type="radio" id="searchAllMonth" value="ALL_DATE" v-model="searchMonth" @click="chkSearchMonthVal($event)">
                                    <label class="btn-m btn-filter" for="searchAllMonth">전체</label>
                                </li>
                            </ul>
                            <div class="body__input body__input-date">
                                <!-- :max="`${searchEndDate}`" -->
                                <input type="date" v-model="searchStartDate" :max="`${todayDate}`" id="searchStartDate" class="form-control" @click="chkSearchSelfDateVal">
                                ~ 
                                <!--  -->
                                <input type="date" v-model="searchEndDate" :min="`${searchStartDate}`" :max="`${todayDate}`" id="searchEndDate" class="form-control" @click="chkSearchSelfDateVal">
                            </div>
                            <!-- <div class="body__input body__input-date">
                                <date-picker
                                v-model="start"
                                :get-classes="getRangeClasses"
                                :default-value="end || new Date()"
                                :disabled-date="disabledStartDate"
                                :disabled-time="disabledStartTime"
                                type="datetime"
                                ></date-picker>
                            <date-picker
                                v-model="end"
                                :get-classes="getRangeClasses"
                                :default-value="start || new Date()"
                                :disabled-date="disabledEndDate"
                                :disabled-time="disabledEndTime"
                                type="datetime"
                                ></date-picker>
                            </div> -->
                        </div>
                    </div>
                    <div class="filter__item filter__item-status">
                        <p class="filter__title">주문 상태</p>
                        <div class="filter__body">
                            <ul class="body__btns body__btns-status">
                                <li><input class="visually-hidden" type="radio" id="statusAll" value="ALL" v-model="searchStatus" @click="chkStatusVal($event)"><label class="btn-m btn-filter" for="statusAll">전체</label></li>
                                <li><input class="visually-hidden" type="radio" id="statusFailure" value="FAIL" v-model="searchStatus" @click="chkStatusVal($event)"><label class="btn-m btn-filter" for="statusFailure">발송실패</label></li>
                                <li><input class="visually-hidden" type="radio" id="statusBooking" value="BOOKING" v-model="searchStatus" @click="chkStatusVal($event)"><label class="btn-m btn-filter" for="statusBooking">발송예약</label></li>
                                <li><input class="visually-hidden" type="radio" id="statusComplete" value="SUCCESS" v-model="searchStatus" @click="chkStatusVal($event)"><label class="btn-m btn-filter" for="statusComplete">발송완료</label></li>
                                <li><input class="visually-hidden" type="radio" id="statusPartFail" value="PARTCANCEL" v-model="searchStatus" @click="chkStatusVal($event)"><label class="btn-m btn-filter" for="statusPartFail">부분취소</label></li>
                                <li><input class="visually-hidden" type="radio" id="statusCancle" value="CANCEL" v-model="searchStatus" @click="chkStatusVal($event)"><label class="btn-m btn-filter" for="statusCancle">주문취소</label></li>
                            </ul>
                        </div>
                    </div>
                </div>              

                <!-- 상세 검색 영역 -->
                <div class="inquiry-filter__detail">
                    <div class="d-flex justify-content-end">
                        <a @click.self="openDetailSearch" class="filter-detail__btn btn-toggle" ref="collapseControl" data-bs-toggle="collapse" href="#detail-search" role="button" aria-expanded="false" aria-controls="detail-search">
                            상세검색 <img class="collapse-icon" src="@/assets/img/icon_down.svg" alt="드롭다운 화살표">
                        </a>
                    </div>
                    <div class="collapse" id="detail-search">
                        <div class="filter-detail__body">
                            <div class="filter__item filter__item-shipping">
                                <p class="filter__title">발송월</p>
                                <div class="filter__body filter__body-shipping">
                                    <div class="body__select body__select-shipping">
                                        <select v-model="defaultYear" id="selectYear" class="form-control">
                                            <option v-for="(year,index) in selectYearList" :value="year.value" v-bind:key="index">{{year.text}}</option>
                                        </select>
                                    </div>
                                    <div class="body__select body__select-shipping">
                                        <select v-model="defaultMonth" id="selectMonth" class="form-control">
                                            <option v-for="(month,index) in selectMonthList" :value="month.value" v-bind:key="index">{{month.text}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="filter__item filter__item-goods">
                                <p class="filter__title">상품명</p>
                                <div class="filter__body">
                                    <input type="text" :value="searchGoodsNm" @input='searchGoodsNm=$event.target.value' placeholder="내용입력" class="form-control">
                                </div>
                            </div>
                            <div class="filter__item filter__item-ordertitle">
                                <p class="filter__title">캠페인명</p>
                                <div class="filter__body">
                                    <input type="text" :value="searchCorpEventNm" @input='searchCorpEventNm=$event.target.value' placeholder="내용입력" class="form-control">
                                </div>
                            </div>
                            <div class="filter__item filter__item-date">
                                <p class="filter__title">수신자번호</p>
                                <div class="filter__body">
                                    <input type="tel" :value="searchReceivermobile" @input='searchReceivermobile=$event.target.value' placeholder="휴대폰번호(-없이 입력)" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 조회 버튼 -->
                <div class="btns">
                    <button type="button" id="searchHistoryBtn" class="btn-l btn-p btn-inquiry" @click="doSearch()">조회</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/event/index.js';
import { addZero } from '@/util';
import { mapState } from 'vuex';
export default {
    data(){
        return{
            searchDate : '',                                                        // 주문조회 설정 - 주문일 라디오 버튼 선택 초기값
            todayDate: new Date().toISOString().substring(0, 10),                   // 현재일자
            searchStartDate: '',                                                    // 검색 - 검색시작일 변수
            searchEndDate: '',                                                      // 검색 - 검색종료일 변수
            searchGoodsNm: '',                                                           // 검색 - 상품명
            searchCorpEventNm: '',                                                       // 검색 - 캠페인명
            searchReceivermobile: '',                                                    // 검색 - 수신자번호
            searchStatus: 'ALL',                                                         // 검색 - 발송상태
            searchMonth: 'ONE_MONTH',                                                    // 검색 - 월
            searchSendDate: '',
            searchValObj: {},                                                       // 검색 값 object
            defaultMonth: '',
            defaultYear: '',
            selectYearList: [],
            selectMonthList: [],
        }
    },

    computed: {
        ...mapState({
            visibleOrdersFilterMobileToastPopup: state => state.modalStore.modalsObj.visibleOrdersFilterMobileToastPopup
        })
    },

    mounted() {
        // '월' input box 세팅
        this.setSearchOneMonth();

        // 발송월 값 세팅
        this.setSelectSendDateValue();
        
        this.controlBodyScroll();
    },

    watch: {
        visibleOrdersFilterMobileToastPopup(){
            this.controlBodyScroll();
        }
    },

    methods: {
        // 토스트팝업 외부영역 클릭 시 토스트팝업 숨김
        closeResultFilter() {
            this.$store.commit('modalStore/setVisibleOrdersFilterMobileToastPopup', false);
            this.closeCollaps(); // 상세버튼 닫기
            document.querySelector('.mobile-toast-popup').style.height = 'auto';
        },

        // 이중스크롤 제어
        controlBodyScroll(){
            if(this.visibleOrdersFilterMobileToastPopup){
                this.$store.commit('modalStore/bodyScrollHandler');
            }else{
                this.$store.commit('modalStore/restoreBodyScroll');
            }
        },

        // 초기화 버튼 클릭
        reset(){
            this.$parent.forceRerender();
        },

        
        // 발송월 셀렉트박스 값 세팅
        setSelectSendDateValue() { 
            // 년도
            let date = new Date();
            let year = date.getFullYear();
            // this.selectedYear = year;

            this.selectMonthList.push({text : '월 선택' , value : ''})
            this.selectYearList.push({text : '년도 선택' , value : ''})

            for(let i = year - 5; i <= year; i++) {
                this.selectYearList.push({text : i + '년' , value : i}) 
            }
            // 월
            for(let i = 1; i <= 12; i++) {
                this.selectMonthList.push({text : addZero(i) + '월' , value : addZero(i)}) 
            }
        },

        // 검색날짜 세팅
        setSearchTotalMonth() {
            let fiveYearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
            this.searchStartDate = fiveYearAgo.toISOString().substring(0, 10); // 시작일
            this.searchEndDate = new Date().toISOString().substring(0, 10); // 종료일
        },

        setSearchOneMonth() {
            let oneMonthAgo = new Date(new Date().setMonth(new Date().getMonth() - 1)); // 1개월 전
            this.searchStartDate = oneMonthAgo.toISOString().substring(0, 10);
            this.searchEndDate = new Date().toISOString().substring(0, 10); // 종료일
        },

        setSearchThreeMonth() {
            let threeMonthAgo = new Date(new Date().setMonth(new Date().getMonth() - 3)); // 3개월 전
            this.searchStartDate = threeMonthAgo.toISOString().substring(0, 10);
            this.searchEndDate = new Date().toISOString().substring(0, 10); // 종료일
        },

        // 조회 영역 - 상세 검색 버튼 Collaps 닫기
        closeCollaps(){
            this.$refs.collapseControl.setAttribute('aria-expanded', 'false');
            const controlTargetId = this.$refs.collapseControl.getAttribute('aria-controls');
            document.querySelector(`#${controlTargetId}`).classList.remove('show');
        },

        // 상세검색 열기
        openDetailSearch(event){
            // 기본 동작은 부트스트랩에서 담당
            const target = event.target;
            const ariaExpandedTrue = document.querySelector('[aria-expanded="true"]');
            if(window.innerWidth < 1200 && target === ariaExpandedTrue){
                document.querySelector('.mobile-toast-popup').style.height = '90%';
            }else{
                document.querySelector('.mobile-toast-popup').style.height = 'auto';
            }
            
        },

        // 주문상태 검색값
        chkStatusVal(event) {
            const element = event.currentTarget.value;
            this.searchStatus = element;            
        },

        // 주문일 검색값
        chkSearchMonthVal(event) {
            const element = event.currentTarget.value;

            if(element === 'ONE_MONTH') {
                this.setSearchOneMonth();
            } else if(element === 'THREE_MONTH') {
                this.setSearchThreeMonth();
            } else {
                this.setSearchTotalMonth();
            }

            this.searchMonth = element;
        },

        //주문일 직접입력 클릭 했을때
        chkSearchSelfDateVal() {
            this.searchMonth = '';
            // this.searchStartDate = new Date().toISOString().substring(0, 10);
            // this.searchEndDate = new Date().toISOString().substring(0, 10);

        },

        // 조회버튼 클릭
        doSearch() {
            // 조회
            if(this.setSearchValue()) {
                eventBus.$emit('searchValObj', this.searchValObj);

            } else {
                alert('발송월을 확인하여주십시오.')
                return;
            }

            this.closeResultFilter();

            if(window.innerWidth < 1200 ){
                
                // 모바일 버전 스크롤 위치 이동
                this.$parent.scrollToTarget('#history-wrap');

                // 상세검색 영역 닫기
                this.closeCollaps();
            }else{
                // PC 버전 스크롤 위치 이동
                this.$parent.scrollToTarget('#visibleShowBtns');
            }
        },

        setSearchValue() {
            // 발송월 값
            if(document.querySelector('#selectYear').value !== '' && document.querySelector('#selectMonth').value === '') {
                return false;
            } else if(document.querySelector('#selectYear').value === '' && document.querySelector('#selectMonth').value !== ''){
                return false; 
            } else {
                this.searchSendDate = document.querySelector('#selectYear').value + document.querySelector('#selectMonth').value;
            }
            
            this.searchValObj = {
                searchGoodsNm : this.searchGoodsNm ,
                searchCorpEventNm : this.searchCorpEventNm ,
                searchReceivermobile : this.searchReceivermobile ,
                searchStatus : this.searchStatus ,
                searchMonth : this.searchMonth ,
                searchStartDate : this.searchStartDate.replaceAll('-','') ,
                searchEndDate : this.searchEndDate.replaceAll('-','') ,
                searchSendDate : this.searchSendDate
            }

            return true;
        },        
    }
}
</script>

<style lang="scss" scoped>
// @import '@/assets/css/orderhistory.scss';
@import '@/assets/css/util/inquiryfilter.scss';


// 주문조회 설정 영역

</style>